import * as types from "./types";

export const defaultState = {
  currentContact: {
    contact: {},
    products: [],
    sold_products: [],
    messages: [],
    page: 1,
    totalPages: 1,
  },
  prevMedia: {
    type: "",
    id: "",
  },
  currentMedia: {
    type: "",
    id: "",
  },
  spotlight: null,
  showModal: null,
};

export function reducer(prevState, action) {
  switch (action.type) {
    case types.CURRENT_CONTACT_UPDATE:
      return {
        ...prevState,
        currentContact: {
          ...action.contact,
        },
      };
    case types.CURRENT_CONTACT_NULL:
      return {
        ...prevState,
        currentContact: null,
      };
    case types.SET_SPOTLIGHT_UPDATE:
      return {
        ...prevState,
        spotlight: action.spotlight,
      };
    case types.SET_SHOW_MODAL:
      return {
        ...prevState,
        showModal: action.showModal,
      };
    case types.UPDATE_CONTACT_MESSAGES:
      const messages = prevState?.currentContact?.messages || [];

      return {
        ...prevState,
        currentContact: {
          ...prevState.currentContact,
          messages: messages.map((item) => {
            if (item?.id === action?.message?.id) {
              return action.message;
            }

            return item;
          }),
        },
      };
    case types.PREV_MEDIA:
      return {
        ...prevState,
        prevMedia: action.prevMedia,
      };
    case types.CURRENT_MEDIA:
      return {
        ...prevState,
        currentMedia: action.currentMedia,
      };
    default:
      return prevState;
  }
}
